import { setToken } from '../../services/apiService'
import * as actionTypes from '../Actions/ActionTypes'

const initialState = {
  token: null,
  userInfo: null,
}

const loginSuccess = (state, action) => {
  let token = action.payload.token
  setToken(token)
  return {
    ...state,
    token,
  }
}

const logoutSuccess = state => {
  return {
    ...state,
    token: null,
    userInfo: null,
  }
}

const getUserInfoSuccess = (state, action) => {
  let userInfo = action.payload.userInfo
  return {
    ...state,
    userInfo,
  }
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.LOGIN_SUCCESS:
      return loginSuccess(state, action)
    case actionTypes.LOGOUT_SUCCESS:
      return logoutSuccess(state)
    case actionTypes.GET_USER_INFO_SUCCESS:
      return getUserInfoSuccess(state, action)
    default:
      return state
  }
}

export default reducer
